import { useEffect } from 'react';
import useRouter from 'AppShell/hooks/useRouter';
import { PageType } from 'AppShell/appshell_types';
import { getPageTypeByUrl } from 'Client/hooks/UrlManager/pageTypeService';
import { useSegmentTracking } from 'Common/segment';
import { convertUrlToListingPageState } from 'Client/components/ListingPage/services/listingPageUrlService';

export const PageMapping = {
    [PageType.HOMEPAGE]: 'Homepage',
    [PageType.CATEGORY]: 'Product Listing',
    [PageType.PDP]: 'Product Detail',
    [PageType.LOOKS]: 'Looks Listing',
    [PageType.CHECKOUT]: 'Checkout',
    [PageType.CART]: 'Cart',
    [PageType.INTERIOR_DESIGN_SERVICE]: 'Westwing Studio',
};

const SegmentPageViewTracker = () => {
    const {
        location: { pathname, search },
        host,
    } = useRouter();
    const segmentTracker = useSegmentTracking();
    const { pageType } = getPageTypeByUrl(pathname, host);

    useEffect(() => {
        let category = '';
        let name = PageMapping[pageType];

        if (pageType === PageType.CATEGORY) {
            const urlState = convertUrlToListingPageState(pathname, search);
            category = urlState.listingPageKey;
        }

        if (pathname.includes('/brands/')) {
            name = 'Brand Listing';
        }

        if (
            pageType === PageType.LOOKS &&
            pathname.split('/').filter(pathSegment => pathSegment && !pathSegment.includes('style')).length > 1
        ) {
            name = 'Looks Detail';
        }

        if (pageType === PageType.INTERIOR_DESIGN_SERVICE && pathname.includes('wizard')) {
            name = 'Westwing Studio Form';
        }

        segmentTracker.page(category, name);
    }, [pageType, pathname, search]);

    return null;
};

export default SegmentPageViewTracker;
